export enum GridSectionState {
  VISIBLE,
  HIDDEN,
  PARTIALLY_HIDDEN,
}
